import { render, staticRenderFns } from "./CarrosManutencaoTipoView.vue?vue&type=template&id=124abf34&"
import script from "./CarrosManutencaoTipoView.vue?vue&type=script&lang=ts&"
export * from "./CarrosManutencaoTipoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports